module.exports = __webpack_public_path__ + "img/tutorial-pc-page6.b2ae7900.png";